import * as React from "react";
import {
  Create,
  SimpleForm,
  ReferenceArrayInput,
  SimpleFormIterator,
  ArrayInput,
} from "react-admin";

import TextInputRA from "../components/TextInputRA";
import HiddenInputRA from "../components/HiddenInputRA";
import SelectInputRA from "../components/SelectInputRA";

import ProductInput from "../components/ProductInput";

const transform = (data) => ({
  ...data,
  level: Number(data.level),
  conditions: [
    { value: data.tier_condition_value, condition_id: data.tier_condition_id },
  ],
  privileges: [
    {
      condition: {
        value: data.condition_value,
        condition_id: data.condition_id,
      },
      item: { value: data.coupon_value, coupon_id: data.coupon_id },
    },
  ],
});

const ImportStockCreate = (props) => (
  <Create {...props} title="Import stock" transform={transform}>
    <SimpleForm>
      <HiddenInputRA source="status" initialValue="Active" />
      <TextInputRA label="Code" source="code" required type="code" />
      <TextInputRA label="Invoice No." source="invoice_no" required />
      <TextInputRA label="Name" source="name" required />
      <TextInputRA label="Description" source="desc" />

      <ArrayInput source="products">
        <SimpleFormIterator>
          <ReferenceArrayInput
            label="Product name"
            source="product_id"
            reference="products"
          >
            <SelectInputRA optionText="name" required />
          </ReferenceArrayInput>
          <TextInputRA label="Quantity" source="qty" type="number" required />
          <TextInputRA label="Cost code" source="cost_code" />
          <TextInputRA label="Cost" source="base_price" required />
          <TextInputRA label="Price" source="retail_price" />
          <TextInputRA label="Final Price" source="final_price" />
          <TextInputRA label="location" source="location" />
          <TextInputRA label="remark" source="remark" />
        </SimpleFormIterator>
      </ArrayInput>

      <ProductInput />
      <ReferenceArrayInput
        label="Supplier"
        source="supplier_id"
        reference="suppliers"
      >
        <SelectInputRA optionText="name" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Create>
);

export default ImportStockCreate;
